<template>
  <div>
    <MyHeader :bg="bgUrl" :name="$isCN() ? '公司动态' : 'Company News'" :nameSecond="$isCN() ? 'Company News' : ''" />
    <div :id="$i18Id($t('最新动态'))"></div>
    <div class="page-content mt-90" v-if="displayItems">
      <SectionTitle title="最新动态" titleEN="News & Events" />
      <div class="news-list mt-50">
        <template v-for="(item, index) in displayItems">
          <nuxt-link v-if="item.id" class="news-item-container" :to="'/html/news/detail/' + item.id + '/'" :key="item.id">
            <www-picture
              class="news-img"
              :w="378 * 4"
              :h="206 * 4"
              :noCompress="!!item.scale"
              :img="item.img"
              :objectFit="item.scale || 'cover'"
            />
            <div class="news-title">{{ item.title }}</div>
          </nuxt-link>
          <div v-else class="news-item-container news-item-container-ph" :key="index"></div>
        </template>
      </div>
      <nuxt-link to="/html/news/all/?type=1" class="see-all-btn" v-if="isMob">{{ $isCN() ? "查看全部" : "Show All" }}</nuxt-link>
      <Pagination :total="totalPage" :current="currentPage" @change="onPageChange" class="pagination" />
      <div :id="$i18Id($t('数据报告'))"></div>
      <template v-if="totalPageData">
        <SectionTitle title="数据报告" titleEN="Industry & Reports" class="mt-90" />
        <div class="news-list mt-50">
          <div
            :class="{
              'news-item-container': true,
              'news-item-container-ph': !item.id,
            }"
            v-for="item in displayItemsData"
            :key="item.id"
            @click="openDataDetail(item)"
          >
            <www-picture class="news-img" :w="378 * 2" :h="206 * 2" :img="item.logImage" />
            <div class="data-title">{{ item.title }}</div>
            <div class="data-desc">{{ item.reportDesc }}</div>
          </div>
        </div>
        <nuxt-link to="/html/news/all/?type=2" class="see-all-btn" v-if="isMob">{{ $isCN() ? "查看全部" : "Show All" }}</nuxt-link>
        <Pagination :total="totalPageData" :current="currentPageData" @change="onPageChangeData" class="pagination" />
      </template>
    </div>
    <div :id="$i18Id($t('媒体资料'))"></div>
    <div class="media-resource center">
      <SectionTitle title="媒体资料" titleEN="Media Library" />
      <div class="list">
        <img w="149" h="67" class="item" src="//img.souche.com/f2e/46aac497ea5b9b0fde182801309f548c.png" />
        <img w="149" h="67" class="item" src="//img.souche.com/f2e/14cba1f2f51af63bb74396acae83ce34.png" />
        <img w="149" h="67" class="item" src="//img.souche.com/f2e/763464376a1df214c05554762d386358.png" />
        <img w="149" h="67" class="item" src="//souche.oss-cn-hangzhou.aliyuncs.com/20230830/png/ec40d8cea7530d251f9fdcb73af2a977.png" />
        <img w="149" h="67" class="item" src="//img.souche.com/f2e/422121689b88f00d3e105c927a86b5f2.png" />
      </div>
      <div class="tip">
        {{ $t("tip") }}
      </div>
    </div>
    <MyFooter />
  </div>
</template>

<script>
import MyHeader from "../../../../components/MyHeader.vue";
import MyFooter from "../../../../components/MyFooter.vue";
import SectionTitle from "../../../../components/SectionTitle.vue";
import Pagination from "../../../../components/Pagination.vue";
import { getAllDataReportTypeList } from "../../../../api/index";
import moment from "moment";
import { generateImageJpg, generateImageWebp } from "../../../../utils/image";

import { media as newsDataMedia, official as newsDataOfficial } from "../../../../data/news";

export default {
  data() {
    return {
      activeNav: "media",
      newsDataMedia,
      newsDataOfficial,
      currentPage: 1,
      dataReport: [],
      currentPageData: 1,
      totalPageData: 0,
    };
  },
  computed: {
    isMob() {
      return this.$isMob();
    },
    bgUrl() {
      return this.$store.state.isMobileSite
        ? "//img.souche.com/x2thc6y8a93gggfc8ksnivoen32e6n2w.png"
        : "//img.souche.com/w518sz1hmwtaup9inso4ej4elzgbcd0t.png";
    },
    displayItems() {
      if (this.isMob) {
        return this.newsDataMedia.slice(0, 3);
      }
      let displayVals = this.newsDataMedia.slice((this.currentPage - 1) * 6, this.currentPage * 6) || [];
      if (!displayVals.length) {
        return displayVals;
      }
      if (displayVals.length < 3) {
        displayVals.push([], [], []);
        displayVals = displayVals.slice(0, 3);
      } else if (displayVals.length < 6) {
        displayVals.push([], [], []);
        displayVals = displayVals.slice(0, 6);
      }
      return displayVals;
    },
    totalPage() {
      return Math.ceil(this.newsDataMedia.length / 6);
    },
    displayItemsData() {
      if (this.isMob) {
        return this.dataReport.slice(0, 3);
      }
      let displayVals = this.dataReport;
      if (displayVals.length < 3) {
        displayVals.push([], [], []);
        displayVals = displayVals.slice(0, 3);
      } else if (displayVals.length < 6) {
        displayVals.push([], [], []);
        displayVals = displayVals.slice(0, 6);
      }
      return displayVals;
    },
  },
  methods: {
    scrollToAnchor() {
      const hash = this.$route.hash;
      if (hash && (hash === "#数据报告" || hash === "#industry___reports")) {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    },
    generateImageJpg,
    generateImageWebp,
    openDataDetail(detail) {
      if (!detail.id) {
        return;
      }
      window.open(`https://zhiyun.souche.com/dataReport/dataReportDetail?id=${detail.id}`, `souche-report-detail-${detail.id}`);
    },
    onPageChange(index) {
      if (index <= 0 || index > this.totalPage) {
        return;
      }
      this.currentPage = index;
    },
    onPageChangeData(index) {
      if (index < 1 || index > this.totalPageData) {
        return;
      }
      this.currentPageData = index;
      this.getData();
    },
    getData() {
      return getAllDataReportTypeList({
        endMonth: moment().format("YYYY-MM-DD"),
        startMonth: moment().subtract(12, "M").format("YYYY-MM-DD"),
        pageSize: 6,
        currentPage: this.currentPageData,
      })
        .then((res) => {
          this.dataReport = res.items || [];
          this.totalPageData = res.totalPage;
        })
        .catch(console.log);
    },
  },
  mounted() {
    this.getData().then(() => {
      this.scrollToAnchor();
    });
  },
  components: {
    MyHeader,
    MyFooter,
    SectionTitle,
    Pagination,
  },
  i18n: {
    messages: {
      zh: {
        媒体资料: "媒体资料",
        title: "公司动态",
        最新动态: "最新动态",
        数据报告: "数据报告",
        tip: "*媒体资料库里的所有图片只供媒体发布新闻使用。使用图片时，请标明图片来源为大搜车集团官方网站。任何人未经大搜车集团授权，不得使用该些图片作任何其他用途。图片可以按比例调整大小，但不能进行其他形式修改。",
      },
      en: {
        title: "NEWS",
        最新动态: "News & Events",
        数据报告: "Industry & Reports",
        媒体资料: "Media Library",
        tip: "* All images in the media library are for media use only. When using images, please indicate the source of the images as the official website of DaSouChe Group. No one is authorized to use these images for any other purpose without the permission of DaSouChe Group. The images can be resized proportionally, but no other form of modification is allowed.",
      },
    },
  },
  head() {
    return {
      title: this.$t("title"),
    };
  },
};
</script>

<style lang="less" scoped>
.pagination {
  margin-top: 44px;
}

.media-resource {
  margin-top: 70px;
  background: linear-gradient(238.88deg, #ffd9cb 0%, rgba(255, 217, 203, 0) 44.73%);
  padding: 82px 0 182px 0;
  flex-direction: column;

  .list {
    display: grid;
    margin-top: 39px;
    overflow: hidden;
    grid-template-columns: 214px 214px 214px 214px 214px;
    column-gap: 32px;
    padding-bottom: 68px;

    .item {
      width: 214px;
      height: 96px;
      box-sizing: border-box;
      overflow: hidden;
      background: linear-gradient(180deg, #fcfbfa 0%, #ffffff 100%);
      box-shadow: 1px 5px 12px #f3ebe8;
      border-radius: 4px;
      padding: 14px 32px;
      transition: transform 0.2s;

      &:hover {
        transform: translateY(-3px);
      }
    }
  }

  .tip {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #2b2c2e;
    max-width: 840px;
    word-wrap: break-word;
  }
}

.news-list {
  display: grid;
  grid-template-columns: repeat(3, min-content);
  row-gap: 32px;
  column-gap: 32px;
  justify-content: center;

  .news-item-container {
    width: 378px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    text-decoration: none;
    cursor: pointer;
    background-color: linear-gradient(180deg, #f6f7fb 0%, #ffffff 100%);
    box-shadow: 1px 5px 12px #f4f1f0;
    border-radius: 4px;

    .news-img {
      display: flex;
      width: 378px;
      height: 206px;
      overflow: hidden;
      background: linear-gradient(180deg, #ffe5db 0%, #ffffff 100%);
    }

    .news-title,
    .data-title {
      overflow: hidden;
      margin: 16px 26px 22px 36px;
      font-size: 16px;
      line-height: 24px;
      text-align: justify;
      color: #2b2c2e;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .data-title {
      margin: 16px 26px 0px 36px;
      -webkit-line-clamp: 1;
    }

    .data-desc {
      margin: 0px 26px 22px 36px;
      font-style: normal;
      font-size: 14px;
      line-height: 24px;
      color: #b4b5b7;
      text-overflow: ellipsis;
      /* autoprefixer: off */
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .news-item-container-ph {
    opacity: 0;
    cursor: unset;
  }
}

@media screen and (min-width: 540px) {
  .news-item-container {
    transition: all;

    &:hover {
      background-color: linear-gradient(180deg, #fcfbfa 0%, #ffffff 100%);
      box-shadow: 1px 5px 12px #f2e2dd;
      transform: translateY(-4px);
      transition: ease all 0.3s;
    }
  }

  .news-img {
    transition: all 1s ease;
  }

  .media-resource {
    .list {
      .item {
        transition: transform 0.2s;
        &:hover {
          transform: translateY(-3px);
        }
      }
    }
  }
}

@media screen and (max-width: 540px) {
  .pagination {
    display: none !important;
  }

  .see-all-btn {
    margin-top: 22px;
    align-self: center;
    padding: 0 22px;
    box-sizing: border-box;
    height: 24px;
    border: 1px solid #ff571a;
    border-radius: 2px;
    box-sizing: border-box;
    font-weight: 400;
    font-size: 10px;
    color: #ff571a;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: none;
    text-decoration: none;
  }

  .news-list {
    grid-template-rows: repeat(3, min-content);
    grid-template-columns: 100%;
    row-gap: 16px;
    column-gap: 0;
    justify-content: center;

    .news-item-container {
      width: 100%;
      overflow: hidden;
      text-decoration: none;
      background-color: linear-gradient(180deg, #f6f7fb 0%, #ffffff 100%);
      box-shadow: 1px 2px 6px #f4f1f0;
      border-radius: 3px;

      .news-img {
        display: flex;
        width: 100%;
        height: calc((100vw - 32px) * (206 / 378));
      }
      .news-title,
      .data-title {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 21px;
        margin: 16px 16px 0 16px;
      }
      .news-title {
        margin: 16px;
      }

      .data-desc {
        font-weight: 400;
        font-size: 11px;
        line-height: 19px;
        margin: 0px 16px 16px 16px;
      }
    }
  }

  .media-resource {
    padding: 48px 0 43px 0;
    margin: 0;
    flex-direction: column;
    background: linear-gradient(0deg, rgba(255, 217, 203, 0.6) 0%, rgba(255, 217, 203, 0) 100%);

    .list {
      margin-top: 17px;
      grid-template-columns: 106px 106px 106px;
      grid-template-rows: min-content min-content;
      column-gap: 12px;
      row-gap: 12px;
      padding-bottom: 20px;

      .item {
        width: 106px;
        height: 48px;
        box-shadow: 1px 2px 6px #f3ebe8;
        border-radius: 2px;
        padding: 7px 15px;
      }
    }

    .tip {
      font-style: normal;
      font-weight: 400;
      font-size: 10px;
      line-height: 18px;
      text-align: center;
      color: #2b2c2e;
      margin: 0 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/_lang/html/news/index.vue